export default __webpack_public_path__ + "static/media/img-0249-afghanistan-full-face.53417f36.png";